import { FC, ReactNode } from 'react';
import ReactDOM from 'react-dom';

const Portal = ({ id = 'portal-root', children }) => {
	const mount = document.getElementById(id);
	if (mount) return ReactDOM.createPortal(children, mount);
	return null;
};

export default Portal;
